
import { authorizeMe, axiosInstance} from './commonHeadApiLogic.js';

// Ensure authorization header is set before making authenticated requests
const withAuthorization = async (apiFunction, ...args) => {
  try {
    await authorizeMe(); // Ensure the Authorization header is set
    return await apiFunction(...args);
  } catch (error) {
    // Handle errors as necessary
    console.error("Error in API request:", error);
    throw error;
  }
};



export async function getStaffsAPI(page = 1,LIMIT) {
  return withAuthorization(async () => {
    return axiosInstance.get(`/api/admins/staff?page=${page}&limit=${LIMIT}`);
  });
}
export const AddStaffAPI = (payload) => {
  return withAuthorization(async () => {
    return axiosInstance.post(`/api/admins/staff`, payload);
  });
};

export const UpdateStaffAPI = (id, payload) => {
  return withAuthorization(async () => {
    return axiosInstance.put(`/api/admins/staff/${id}`, payload);
  });
};

export const DeleteStaffAPI = (id) => {
  return withAuthorization(async () => {
    return axiosInstance.delete(`/api/admins/staff/${id}`);
  });
};

